// Inline share-link cards used by More.js (no separate route).
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Copy, Share2, Link as LinkIcon, Calendar } from "lucide-react";

export default function ShareLinkCards() {
  const [links, setLinks] = useState(null);
  const [copied, setCopied] = useState("");

  useEffect(() => {
    api.get("/public/share-links").then(setLinks).catch(() => setLinks({ onboard: "", schedule: "" }));
  }, []);

  const copy = async (url, label, headline) => {
    const text = `${headline}\n${url}`;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(label);
      setTimeout(() => setCopied(""), 1500);
    } catch { alert(text); }
  };

  const share = async (url, headline) => {
    const data = { title: "Studio Grape", text: headline, url };
    if (navigator.share) {
      try { await navigator.share(data); } catch (_) {}
    } else {
      copy(url, "share", headline);
    }
  };

  return (
    <>
      <LinkCard
        icon={<LinkIcon size={16} color="var(--brand)" />}
        title="Customer Onboarding Form"
        headline="Onboard with Studio Grape!"
        url={links?.onboard || ""}
        onCopy={() => copy(links?.onboard, "onboard", "Onboard with Studio Grape!")}
        onShare={() => share(links?.onboard, "Onboard with Studio Grape!")}
        copied={copied === "onboard"}
        testId="onboard"
      />
      <LinkCard
        icon={<Calendar size={16} color="var(--brand)" />}
        title="Meeting Scheduler"
        headline="Book a meeting with Studio Grape!"
        url={links?.schedule || ""}
        onCopy={() => copy(links?.schedule, "schedule", "Book a meeting with Studio Grape!")}
        onShare={() => share(links?.schedule, "Book a meeting with Studio Grape!")}
        copied={copied === "schedule"}
        testId="schedule"
      />
    </>
  );
}

function LinkCard({ icon, title, headline, url, onCopy, onShare, copied, testId }) {
  return (
    <div className="sg-card" style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
        {icon} <span style={{ fontSize: 14, fontWeight: 800 }}>{title}</span>
      </div>
      <div style={{ fontSize: 13, fontWeight: 700, color: "var(--brand)", marginBottom: 4 }}>{headline}</div>
      <div style={{
        fontSize: 11, color: "var(--muted)", padding: 8, background: "var(--surface-subtle)",
        borderRadius: 8, fontFamily: "monospace", overflowWrap: "anywhere", marginBottom: 10,
        maxHeight: 60, overflow: "hidden",
      }} data-testid={`${testId}-link`}>{url || "Loading…"}</div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <button className="sg-btn" onClick={onCopy} data-testid={`${testId}-copy`}>
          <Copy size={14} /> {copied ? "Copied!" : "Copy"}
        </button>
        <button className="sg-btn sg-btn-primary" onClick={onShare} data-testid={`${testId}-share`}>
          <Share2 size={14} /> Share
        </button>
      </div>
    </div>
  );
}
